import React, { useCallback, useEffect, useState } from "react";
import useRequest from "../hooks/useRequest";
import apiPath from "../constants/apiPath";
import { Severty, ShowToast } from "../helper/toast";
import TemplateEditor from "../components/TemplateEditor";

const EmailTemplateManager = () => {
  //----------- Constants-----------
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [loading, setLoading] = useState(false);
  const { request } = useRequest();

  // ---------- Handlers -----------
  const fetchAllTemplates = useCallback(() => {
    setLoading(true);
    request({
      url: `/api/admin/email-template`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        let templateData = [];
        if (data?.data) {
          if (Array.isArray(data.data)) {
            templateData = data.data;
          }
        } else if (Array.isArray(data)) {
          templateData = data;
        }

        setTemplates(Array.isArray(templateData) ? templateData : []);

        // If we had a selected template, try to find the updated version
        if (selectedTemplate) {
          const updatedTemplate = templateData.find(
            (t) => t.id === selectedTemplate.id
          );
          if (updatedTemplate) {
            setSelectedTemplate(updatedTemplate);
          }
        }
      },
      onError: (error) => {
        setLoading(false);
        setTemplates([]);
        ShowToast("Failed to fetch email templates", Severty.ERROR);
      },
    });
  }, [selectedTemplate]);

  //   --------- Use Effects -----------
  useEffect(() => {
    fetchAllTemplates();
  }, []);

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
  };

  return (
    <div className="email-template-manager container-fluid">
      <div className="row">
        <div className="col-md-4 template-list-panel">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Email Templates</h3>
            </div>
            <div className="card-body">
              {loading ? (
                <div className="text-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <div className="template-list">
                  {templates.length > 0 ? (
                    templates.map((tpl) => (
                      <div
                        key={tpl.id}
                        className={`template-item card mb-2 ${
                          selectedTemplate?.id === tpl.id ? "active" : ""
                        }`}
                        onClick={() => handleTemplateSelect(tpl)}
                      >
                        <div className="card-body">
                          <h5 className="card-title">{tpl.template_key}</h5>
                          <p className="card-text">{tpl.subject}</p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-muted">No templates found</p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="col-md-8 template-editor-panel">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Template Editor</h3>
            </div>
            <div className="card-body">
              {selectedTemplate ? (
                <TemplateEditor
                  template={selectedTemplate}
                  onUpdate={fetchAllTemplates}
                />
              ) : (
                <div className="text-center py-5">
                  <h4>Select a template to edit</h4>
                  <p className="text-muted">
                    Choose a template from the list to start editing
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailTemplateManager;
